import { ButtonProps } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/ClearOutlined'
import Button from 'elements/button/Button'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, styled, Typography } from 'opensolar-ui'
import React, { FC, PropsWithChildren } from 'react'

interface ConfirmHeaderProps {
  title: string
  onClose?: () => void
  ui3?: boolean
  bold?: boolean
  fontSize?: number | string
}

const StyledDialog = styled(Dialog)({
  zIndex: 2600, // This Dialog is sometimes used inside another dialog
  // ^ updated the above from 2000 to 2600 to fix the issue with the dialog being behind menus
})

const ConfirmHeader = (props: PropsWithChildren<ConfirmHeaderProps>) => {
  const headerStyle = {
    ...(props.bold ? { fontWeight: 'bold' } : {}),
    ...(props.fontSize ? { fontSize: props.fontSize } : {}),
  }
  return (
    <DialogTitle>
      {props.children && (
        <Typography variant="h6" style={headerStyle}>
          {props.children}
        </Typography>
      )}
      {props.title && (
        <>
          {props.ui3 ? (
            props.title
          ) : (
            <Typography variant="h6" style={headerStyle}>
              {props.title}
            </Typography>
          )}
        </>
      )}
      {props.onClose ? (
        <IconButton aria-label="close" onClick={props.onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}

export interface ConfirmProps {
  open: boolean
  model?: boolean
  header?: {
    title: string
    bold?: boolean
    fontSize?: number | string
  }
  content?: string | React.ReactNode
  buttons: ButtonInfo[]
  onClose?: () => void
  ui3?: boolean
  fullWidth?: boolean
}

export type ButtonRender = () => React.ReactNode
export type ButtonInfo = ButtonProps | ButtonRender

const Confirm: FC<ConfirmProps> = (props) => {
  return (
    <div>
      <StyledDialog open={props.open} fullWidth={props.fullWidth}>
        {props.header && <ConfirmHeader onClose={props.onClose} {...props.header} ui3={props.ui3} />}
        {props.content && <DialogContent>{props.content}</DialogContent>}
        <DialogActions>
          {props.buttons &&
            props.buttons.map((button, index) =>
              typeof button === 'function' ? button() : <Button key={index} {...button} />
            )}
        </DialogActions>
      </StyledDialog>
    </div>
  )
}

export default Confirm
